import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
function SystemStatePage({ code, description, title }) {
  const { translate } = useLanguage();
  return <main className="system-page"><section><p className="system-page__code">{code}</p><h1>{translate(title)}</h1><p>{translate(description)}</p><Link className="button button--primary" to="/">{translate('Return home')}</Link></section></main>;
}
export default SystemStatePage;

